module.exports = __webpack_public_path__ + "media/icons/pt-b10483d0.png";